let glightboxInstance = null;

function initGLightbox() {
  if (typeof GLightbox === 'undefined') return;

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  // Prevent raw image navigation on mobile
  document.querySelectorAll('a.glightbox').forEach((a) => {
    if (a.dataset.mobileHandlerAttached) return;

    a.addEventListener('click', (e) => {
      if (!window.matchMedia('(min-width: 768px)').matches) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    a.dataset.mobileHandlerAttached = 'true';
  });

  if (!isDesktop) {
    if (glightboxInstance) {
      glightboxInstance.destroy();
      glightboxInstance = null;
    }
    return;
  }

  // Count how many lightbox items exist
  const items = document.querySelectorAll('a.glightbox');
  const hasMultipleItems = items.length > 1;

  if (!glightboxInstance) {
    glightboxInstance = GLightbox({
      selector: 'a.glightbox',
      touchNavigation: hasMultipleItems,
      loop: hasMultipleItems,
      closeButton: true,
      draggable: hasMultipleItems,
      zoomable: hasMultipleItems
    });
  }
}

document.addEventListener('DOMContentLoaded', initGLightbox);
document.addEventListener('shopify:section:load', initGLightbox);
window.addEventListener('resize', initGLightbox);
